import React from 'react';

class SmartTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      new_value_id: '',
      new_value_title: '',
    };
  }

  idOnChange(e) {
    this.props.idOnChange(this.props.idx, e.target.value);
  }

  titleOnChange(e) {
    this.props.titleOnChange(this.props.idx, e.target.value);
  }

  autocompleteOnChange(e) {
    this.props.autocompleteOnChange(this.props.idx, e.target.value);
  }

  valueIdOnChange(idx, e) {
    this.props.valueIdOnChange(this.props.idx, idx, e.target.value);
  }

  valueTitleOnChange(idx, e) {
    this.props.valueTitleOnChange(this.props.idx, idx, e.target.value);
  }

  newValueIdOnChange(e) {
    this.setState({ new_value_id: e.target.value });
  }

  newValueTitleOnChange(e) {
    this.setState({ new_value_title: e.target.value });
  }

  valueAddNew() {
    if (this.state.new_value_id !== '' && this.state.new_value_title !== '') {
      this.props.valueAddNew(
        this.props.idx,
        this.state.new_value_id,
        this.state.new_value_title,
      );
      this.setState({ new_value_id: '', new_value_title: '' });
    }
  }

  valueRemove(idx) {
    this.props.valueRemove(this.props.idx, idx);
  }

  addNewSmartTag() {
    this.props.addNewSmartTag();
  }

  removeSmartTag() {
    this.props.removeSmartTag(this.props.idx);
  }

  render() {
    let values;
    if (this.props.values) {
      values = this.props.values.map((value, idx) => {
        return (
          <div key={idx} className="row" style={{ paddingBottom: '5px' }}>
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Identifikátor tagu"
                value={value.id}
                onChange={this.valueIdOnChange.bind(this, idx)}
              />
            </div>
            <div className="col-md-5">
              <input
                type="text"
                className="form-control"
                placeholder="Tag"
                value={value.title}
                onChange={this.valueTitleOnChange.bind(this, idx)}
              />
            </div>
            <div className="col-md-2">
              <a
                href="javascript:;"
                className="btn btn-danger btn-sm"
                onClick={this.valueRemove.bind(this, idx)}
              >
                <span className="fa fa-remove" />
              </a>
            </div>
          </div>
        );
      });
    }
    let add_button, remove_button;
    if (this.props.is_new) {
      add_button = (
        <div>
          <a
            href="javascript:;"
            className="btn btn-primary btn-sm"
            onClick={this.addNewSmartTag.bind(this)}
          >
            <span className="fa fa-plus" />
            &nbsp;Pridať nový typ
          </a>
        </div>
      );
    } else {
      remove_button = (
        <div className="btn-group pull-right">
          <a
            href="javascript:;"
            className="btn btn-danger btn-xs"
            onClick={this.removeSmartTag.bind(this)}
          >
            <span className="fa fa-trash" />
            &nbsp;Odstrániť
          </a>
        </div>
      );
    }
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <strong>
            {this.props.is_new
              ? 'Pridať nový povolený typ'
              : 'Povolený Smart tag'}
          </strong>
          {remove_button}
        </div>
        <div className="panel-body">
          <div className="form-group clearfix">
            <div className="col-md-4">Identifikátor</div>
            <div className="col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="Identifikátor smart tagu"
                value={this.props.id}
                onChange={this.idOnChange.bind(this)}
              />
            </div>
          </div>
          <div className="form-group clearfix">
            <div className="col-md-4">Názov</div>
            <div className="col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="Názov smart tagu"
                value={this.props.title}
                onChange={this.titleOnChange.bind(this)}
              />
            </div>
          </div>
          <div className="form-group clearfix">
            <div className="col-md-4">Povolené hodnoty</div>
            <div className="col-md-8">
              <div className="row" style={{ paddingBottom: '5px' }}>
                <div className="col-md-5">
                  <em>Identifikátor</em>
                </div>
                <div className="col-md-5">
                  <em>Tag</em>
                </div>
                <div className="col-md-2" />
              </div>
              {values}
              <div className="row" style={{ paddingBottom: '5px' }}>
                <div className="col-md-5">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Identifikátor tagu"
                    value={this.state.new_value_id}
                    onChange={this.newValueIdOnChange.bind(this)}
                  />
                </div>
                <div className="col-md-5">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Tag"
                    value={this.state.new_value_title}
                    onChange={this.newValueTitleOnChange.bind(this)}
                  />
                </div>
                <div className="col-md-2">
                  <a
                    href="javascript:;"
                    className="btn btn-primary btn-sm"
                    onClick={this.valueAddNew.bind(this)}
                  >
                    <span className="fa fa-plus" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="form-group clearfix center">{add_button}</div>
        </div>
      </div>
    );
  }
}

export default SmartTag;



// WEBPACK FOOTER //
// ./src/js/app/admin/SmartTag.jsx